import { createContext, useContext } from 'react'
import type { ChannelProductPullJob } from './types'

export type ImportSetupKind = 'products' | 'orders' | 'noon-catalog' | 'noon-sales'
export interface ImportsContextValue {
  openAll: () => void
  openForChannel: (connectionId: number) => void
  openSetup: (setup: ImportSetupKind, connectionId: number) => void
  showProductJob: (job: ChannelProductPullJob) => void
  refreshChannels: () => void
  revision: number
  reviewUnmapped?: (connectionId: number) => void
  runningCount: number
  attentionCount: number
}
export const ImportsContext = createContext<ImportsContextValue | null>(null)
export function useSharedImports() {
  const value = useContext(ImportsContext)
  if (!value) throw new Error('SharedImportsProvider is required')
  return value
}
